import { render, staticRenderFns } from "./SubscribeToPackageForm.vue?vue&type=template&id=681483ca&scoped=true"
import script from "./SubscribeToPackageForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubscribeToPackageForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SubscribeToPackageForm.vue?vue&type=style&index=0&id=681483ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681483ca",
  null
  
)

export default component.exports